import styled from 'styled-components';

export const dotDiameter = 16;
const dotLineGap = 4;

// Color definitions
const activeColor = '#0046ff';
const inactiveColor = '#a3a3a3';
const activeBg = '#f2f6ff';
const inactiveBg = '#fff';

// Common helpers
const textColor = (active?: boolean) => (active ? activeColor : inactiveColor);
const dotBorder = (active?: boolean) => `2px solid ${textColor(active)}`;
const dotBg = (active?: boolean) => (active ? activeBg : inactiveBg);

export const TimelineWrapper = styled.div`
  display: flex;
  background: #fff;
  padding: 48px 24px;
`;

export const TimelineItem = styled.div`
  flex: 1;
  padding: 0 0 22px;
  min-height: unset;
  position: relative;
  font-size: 14px;
`;

// Horizontal line
export const TimelineLine = styled.div<{ active?: boolean }>`
  position: absolute;
  left: ${dotDiameter + dotLineGap}px;
  right: ${dotLineGap}px;
  top: 50%;
  transform: translateY(-50%);
  height: 2px;
  width: unset;
  box-sizing: border-box;
  border-top: 2px solid ${({ active }) => textColor(active)};
`;

// Dot section
export const DotContainer = styled.div`
  left: 0;
  bottom: 0;
  top: unset;
  position: absolute;
  height: 22px;
  width: 100%;
  text-align: center;
`;

export const DotContent = styled.div`
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  width: ${dotDiameter}px;
  height: ${dotDiameter}px;
`;

export const Dot = styled.div<{ active?: boolean }>`
  top: unset;
  position: relative;
  margin-top: unset;
  width: ${dotDiameter}px;
  height: ${dotDiameter}px;
  box-sizing: border-box;
  border-radius: 40px;
  border: ${({ active }) => dotBorder(active)};
  background: ${({ active }) => dotBg(active)};
`;

// Vertical line for "Today"
export const TodayLine = styled.div`
  top: unset;
  position: relative;
  background: #52c41a;
  width: 2px;
  height: 22px;
  flex-shrink: 0;
`;

// Content block
export const ContentWrapper = styled.div`
  position: relative;
`;

export const ContentText = styled.div<{ active?: boolean }>`
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
  line-height: 20px;
  letter-spacing: -0.14px;
  color: ${({ active }) => textColor(active)};
`;

export const ContentName = styled.div`
  display: flex;
  gap: 4px;
  font-weight: 700;
`;
